import type { ReactNode } from 'react'

interface ListPageHeaderProps {
  title: ReactNode
  subtitle?: ReactNode
  /** Right-side actions (typically the AddButton). */
  actions?: ReactNode
}

/**
 * Dense header for list-with-table pages (Klienci, Umowy, Produkty, Role,
 * Zespoły, ...). Matches {@link DetailHeader} visual rhythm so list <-> detail
 * transitions feel consistent.
 *
 * For informational pages without a table (Dashboard, /me, Admin, ComingSoon)
 * use {@link PageHeader} instead - it has a larger title and no border.
 */
export function ListPageHeader({ title, subtitle, actions }: ListPageHeaderProps) {
  return (
    <header className="px-4 py-3 border-b">
      <div className="flex items-start justify-between gap-4">
        <div className="flex flex-col gap-0.5 min-w-0">
          <h1 className="text-lg font-semibold truncate">{title}</h1>
          {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
        </div>
        {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
      </div>
    </header>
  )
}
